import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { request } from './client.ts';
import { qk } from './keys.ts';
import type { ApiKey, CreatedApiKey } from '@seencast/shared';

// Personal API keys for MCP (docs/05, docs/08).
export function listApiKeys(): Promise<{ items: ApiKey[] }> {
  return request<{ items: ApiKey[] }>('/me/api-keys');
}

export function useApiKeys() {
  return useQuery({ queryKey: qk.apiKeys, queryFn: listApiKeys });
}

export function useCreateApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (name: string) =>
      request<CreatedApiKey>('/me/api-keys', { method: 'POST', body: { name } }),
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.apiKeys }),
  });
}

export function useRevokeApiKey() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => request<void>(`/me/api-keys/${id}`, { method: 'DELETE' }),
    onSuccess: () => qc.invalidateQueries({ queryKey: qk.apiKeys }),
  });
}
